/*
    判断当前平台，android或ios
*/
const u = window.navigator.userAgent || ''

export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
export const isIOS = !!u.match(/Mac OS X/i)
export const isPC = !isAndroid && !isIOS

export default () => (isAndroid ? 1 : isIOS ? 2 : 0)
